import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';

import { useStores } from '@/hooks/use-stores';

import Card from '../../Card';
import YearPager from '../../YearPager';
import YearlyViewContainer from '../../YearlyViewContainer';
import StationRiskYearlyGraph from './StationRiskYearlyGraph';

const StationRiskYearlyView = observer(
  ({ tabKey, ...rest }: { tabKey?: string; className?: string; style: React.CSSProperties }) => {
    const { t } = useTranslation();
    const { energySavingsStore } = useStores();

    const tabItems = [
      {
        label: t('System Health'),
        key: 'SystemHealth',
        children: <StationRiskYearlyGraph yearToPresent={energySavingsStore.requestedYear} />,
      },
    ];

    return (
      <YearlyViewContainer {...rest}>
        <div className="card">
          <Card className="system-health-card">
            <Tabs
              activeKey={tabKey}
              animated={{
                inkBar: true,
                tabPane: false,
              }}
              items={tabItems}
            />
            <div className={'footer'}>
              <span className={'asterisk'}>* </span>
              {t('SHOWING_CURRENT_MONTH_ACCUMULATED_DATA')}
              <YearPager energySavingsStore={energySavingsStore} />
            </div>
          </Card>
        </div>
      </YearlyViewContainer>
    );
  },
);

export default StationRiskYearlyView;
